<template>
  <div class="smsMessage">
    <div class="searchForm">
      <el-form ref="form" :model="form" label-width="75px" @submit.native.prevent>
        <el-row :gutter="12">
          <el-col :span="4">
            <el-form-item label="接收组编码" label-width="80px">
              <el-input v-model="searchForm.code" autocomplete="off" placeholder="接收组编码"
                @keyup.enter.native="getGroupList(1)" />
            </el-form-item>
          </el-col>
          <el-col :span="4" style="margin-left: 15px">
            <el-form-item label="接收组模式" label-width="80px">
              <el-select clearable v-model="searchForm.type" @change="getGroupList(1)" placeholder="请选择接收组模式">
                <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button style="margin-left: 20px" type="primary" @click="getGroupList(1)">查询</el-button>
            <el-button type="primary" @click="showEditDialog(1)">新增</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="dataBox">
      <el-table v-loading="loading" element-loading-text="数据加载中" :data="tableData" stripe  max-height="700">
        <el-table-column prop="id" label="id" v-if="false" />
        <el-table-column prop="receiveCode" label="接收组编码" />
        <el-table-column prop="type" label="接收组模式">
          <template slot-scope="scope">
            {{ parseType(scope.row.type) }}
          </template>
        </el-table-column>
        <el-table-column prop="des" label="描述" />
        <el-table-column prop="receiveUserName" label="接收者">
          <template slot-scope="scope">
            {{ parseUser(scope.row.receiveUserName) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.enableUse === 1 ? 'success' : 'danger'">{{
                scope.row.enableUse === 1 ? '启用' : '禁用'
            }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="updateDate" label="更新时间" />
        <el-table-column label="操作" fixed="right" width="250">
          <template slot-scope="scope">
            <el-button type="text" @click="showEditDialog(2, scope.row)">编辑</el-button>
            <el-popconfirm @confirm="updateEnableUse(scope.row)" icon="el-icon-info" icon-color="red" title="确认修改状态吗？"
              style="margin-left: 0.625rem">
              <el-button type="text" slot="reference">
                {{ scope.row.enableUse === 1 ? '禁用' : '启用' }}
              </el-button>
            </el-popconfirm>
            <el-popconfirm @confirm="deleteGroup(scope.row.id)" icon="el-icon-info" icon-color="red" title="确认删除吗？"
              style="margin-left: 0.625rem">
              <el-button type="text" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>

        </el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
        :page-sizes="[10, 20, 50]" :page-size="pageSize" :current-page.sync="pageNum" @size-change="sizeChangeClick"
        @current-change="currChangeClick" @prev-click="prevClick" @next-click="nextClick" />
    </div>
    <!-- 编辑弹框 -->
    <el-dialog :title="(operateType === 1 ? '新增' : '编辑')" :visible.sync="dialogEditFormVisible" width="50%"
      :before-close="closeDialog">
      <el-form :model="form" ref="groupForm" label-width="120px" :rules="rules">
        <el-form-item label="接收组编码" prop="receiveCode">
          <el-input v-model="form.receiveCode" placeholder="请输入接收组编码" />
        </el-form-item>
        <el-form-item label="描述" prop="des">
          <el-input v-model="form.des" placeholder="请输入描述" />
        </el-form-item>
        <el-form-item label="接收组模式" prop="type">
          <el-select v-model="form.type" placeholder="请选择" @change="clearValue">
            <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="接收者" prop="receiveUserList">
          <el-select v-if="form.type !== 'DEPT'" v-model="form.receiveUserList" filterable default-first-option
            placeholder="请输入关键字搜索" :remote="true" multiple :remote-method="searchReceiveUser" :loading="loading">
            <el-option v-for="item in searchUserList" :key="item.account" :label="item.account + ' ' + item.name"
              :value="item.account">
            </el-option>
          </el-select>
          <!-- v-model="form.receiveUserList" -->
          <el-select v-if="form.type === 'DEPT'" class="form-input" v-model="form.receivelabelList" filterable
            style="width: 100%;">
            <el-option style="height: auto;" :value="[]">
              <el-tree :data="deptList" show-checkbox :check-strictly="true" :default-expand-all="false"
                :default-expanded-keys="form.receiveUserList" :default-checked-keys="form.receiveUserList"
                :expand-on-click-node="false" ref="roleTree" node-key="deptCode" @check="handleNodeCheck"
                @node-click="handleNodeClick" :props="props">
              </el-tree>
            </el-option>
          </el-select>

        </el-form-item>
        <el-form-item label="启用" prop="enableUse">
          <el-switch v-model="form.enableUse" active-text="是" inactive-text="否" active-color="green"
            inactive-color="red" :active-value="1" :inactive-value="0">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveGroup" :loading="saveLoading">保存</el-button>
        <el-button type="primary" @click="closeDialog">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import httpUrl from "@/static/configUrl";


export default {
  name: "group",
  components: {},
  data() {
    return {
      // clientId: this.$store.state.request.appId,
      form: {
        id: '',
        receiveCode: '',
        type: '',
        des: '',
        enableUse: 1,
        receiveUserList: [],
        receivelabelList: []//label
      },
      operateType: 1,
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      saveLoading: false,
      loading: false,
      dialogEditFormVisible: false,
      dialogFormVisible: false,
      searchForm: {
        type: '',
        code: ''
      },
      treeProps: {
        children: 'children',
        label: 'deptName',
      },
      typeOptions: [
        {
          label: "用户",
          value: "USER"
        },
        {
          label: "角色",
          value: "ROLE"
        },
        // {
        //   label: "组织",
        //   value: "DEPT"
        // },
        // {
        //   label: "域群组",
        //   value: "ADGROUP"
        // },
      ],
      searchUserList: [],
      deptList: [],
      selectDeptList: [],
      rules: {
        receiveCode: [
          { required: true, message: '请输入接收组编码', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择接收组模式', trigger: 'blur' }
        ],
        receiveUserList: [
          { required: true, message: '请选择接收人', trigger: 'blur' }
        ]
      },

      props: {
        children: 'children',
        label: 'deptName',
        value: 'deptCode'
      },
      nodeNames: [],
    }
  },
  watch: {
    selectTreeNodeFilterText(val) {
      this.$refs.selectTree.filter(val);
    },
    clientId() {
      this.getGroupList()
    }
  },
  computed: {
    clientId(){
      return this.$store.state.request.appId
    }
  },
  created() {
    this.getGroupList()
  }
  ,
  mounted() {
  }
  ,
  methods: {
    saveGroup() {
      this.$refs['groupForm'].validate((valid) => {
        if (valid) {
          const that = this
          that.saveLoading = true
          let _funName = '/receive/group/add'
          let httpType = 'httpPost'
          if (that.operateType === 2) {
            _funName = '/receive/group/update'
          }
          that.$set(that.form, 'curl', httpUrl.messageUrl + _funName)
          that.$store.dispatch(httpType, that.form).then(function (res) {
            that.saveLoading = false
              that.$message({
                message: res.message,
                type: 'success',
                duration: 500,
                onClose: function () {
                  that.dialogEditFormVisible = false
                  that.getGroupList()
                }
              })
          }, function (err) {
            that.saveLoading = false
          }
          )
          return true
        } else {
          return false
        }
      })
    }
    ,
    clearValue() {
      this.form.receiveUserList = []
      //解决历史搜索记录问题
      this.searchUserList = []
    },
    searchReceiveUser(param, type) {
      const that = this
      if (!that.form.type) return
      const searchParam = {
        curl: httpUrl.messageUrl + '/baseInfo/search',
        searchParam: param,
        type: that.form.type,
        clientId: that.clientId
      }
      that.loading = true
      that.$store.dispatch('httpGet', searchParam).then(function (res) {
        that.searchUserList = res.data
        that.loading = false
      }, function (err) {
        console.log(err.message)
        that.loading = false
      })
    },
    searchDept() {
      const that = this
      const searchParam = {
        curl: httpUrl.messageUrl + '/baseInfo/search',
        type: 'DEPT',
        clientId: that.clientId
      }
      that.loading = true
      that.$store.dispatch('httpGet', searchParam).then(function (res) {
        that.deptList = res.data
        that.loading = false
      }, function (err) {
        console.log(err.message)
        that.loading = false
      })
    },

    handleClick(data, checked, node) {
      if (checked) {
        this.$refs.tree.setCheckedNodes([data]);
      }
    }
    ,
    parseUser(userList) {
      console.log(userList)
      let name = '';
      for (let i = 0; i < userList.length; i++) {
        if (i === userList.length - 1) {
          name = name + userList[i]
        } else {
          name = name + userList[i] + ','
        }
      }
      return name
    }
    ,
    parseType(type) {
      switch (type) {
        case 'USER':
          return "用户"
        case 'ROLE':
          return "角色"
        case 'DEPT':
          return "组织"
        case 'ADGROUP':
          return "域群组"
        default:
          return "未知类型"
      }
    }
    ,
    initDatePickValue() {
      let d = new Date
      this.form.sendTime.push(d)
      let startTime = d.getTime() - 24 * 3600 * 1000 * 30;
      let startDate = new Date(startTime)
      this.form.sendTime.unshift(startDate)
    }
    ,
    getGroupList(_pageNum) {
      const that = this
      if (_pageNum === 1) {
        that.pageNum = 1
      }
      that.loading = true
      const _data = {
        curl: httpUrl.messageUrl + '/receive/group/list',
        clientId: that.clientId,
        page: that.pageNum,
        size: that.pageSize,
        type: that.searchForm.type,
        receiveCode: that.searchForm.code
      }
      that.$store.dispatch('httpGet', _data).then(function (res) {
        that.tableData = res.data.content
        that.total = parseInt(res.data.total)
        that.loading = false
      }, function (err) {
        console.log(err.message)
        that.loading = false
      })
    }
    ,
    deleteGroup(id) {
      const that = this
      let updateForm = {}
      this.$set(updateForm, 'curl', httpUrl.messageUrl + "/receive/group/delete/" + id)
      this.$store.dispatch('httpDelete', updateForm).then(function (res) {
        that.saveLoading = false
          that.$message({
            message: res.message,
            type: 'success',
            duration: 500,
            onClose: function () {
              that.dialogEditFormVisible = false
              that.getGroupList()
            }
          })
      }, function (err) {
        that.saveLoading = false
      }
      )
    }
    ,
    updateEnableUse(rowData) {
      const that = this
      let updateForm = {}
      this.$set(updateForm, 'curl', httpUrl.messageUrl + "/receive/group/update/" + rowData.id + "/" + rowData.enableUse)
      this.$store.dispatch('httpPut', updateForm).then(function (res) {
        that.saveLoading = false
          that.$message({
            message: res.message,
            type: 'success',
            duration: 500,
            onClose: function () {
              that.dialogEditFormVisible = false
              that.getGroupList()
            }
          })
      }, function (err) {
        that.saveLoading = false
      }
      )
    }
    ,
    // 分页 每页条数改变
    sizeChangeClick(val) {
      this.pageSize = val
      this.getGroupList()
    }
    ,
    // 分页 改变当前页
    currChangeClick(val) {
      this.pageNum = val
      this.getGroupList()
    }
    ,
    // 分页 上一页
    prevClick(val) {
      this.pageNum = val
      this.getGroupList()
    }
    ,
    // 分页 下一页
    nextClick(val) {
      this.pageNum = val
      this.getGroupList()
    }
    ,

    // 编辑-弹出窗
    showEditDialog(operType, rowData) {
      //operType=1 新增  operType=2 编辑
      this.form = {
        clientId: this.$route.query.clientId,
        id: '',
        receiveCode: '',
        type: '',
        des: '',
        enableUse: 1,
        receiveUserList: []
      }
      if (operType === 1) {
        this.form.receiveUserList = []
      }

      this.operateType = operType
      if (operType === 2) {
        this.form = {
          clientId: this.clientId,
          id: rowData.id,
          receiveCode: rowData.receiveCode,
          type: rowData.type,
          des: rowData.des,
          enableUse: rowData.enableUse,
          receiveUserList: rowData.receiveUserList,
          receivelabelList: rowData.receiveUserName//编辑label
        }
      }
      // this.searchDept()
      this.dialogEditFormVisible = true
    }
    ,
    closeDialog() {
      this.dialogEditFormVisible = false;
      this.$refs['groupForm'].clearValidate();
    }
    ,
    //点击节点
    handleNodeClick(data) {
      const checkKeys = this.$refs.roleTree.getCheckedKeys();
      if (checkKeys.indexOf(data.code) === -1) {
        const checkedNodes = this.$refs.roleTree.getCheckedNodes();
        checkedNodes.push(data);
        this.selectDeptList = checkedNodes.map(m => {
          return m.deptName
        });
        // pph
        this.form.receivelabelList = checkedNodes.map(m => {
          return m.deptName
        });

        this.form.receiveUserList = checkedNodes.map(m => {
          return m.deptCode
        });
        this.$refs.roleTree.setCheckedNodes(checkedNodes);
        console.log(this.form.receivelabelList)
      }
    }
    ,
    //点击复选框
    handleNodeCheck(data, checked) {
      this.form.receiveUserList = checked.checkedNodes.map(m => {
        return m.deptCode
      });
      this.selectDeptList = checked.checkedNodes.map(m => {
        return m.deptName
      });
      // pph
      this.form.receivelabelList= checked.checkedNodes.map(m => {
        return m.deptName
      });
        console.log(this.form.receivelabelList)
    },

  }
}
</script>

<style lang="scss" scoped>
.smsMessage {
  .searchForm {
    /*background: #fff;*/
    /*padding-top: 10px;*/
    padding-left: 10px;

    /*height: 45px;*/
    .el-input {
      width: 200px;
    }
  }
}
</style>
<style>
.smsMessage .searchForm .el-form-item {
  display: inline-block;
}

.smsMessage .searchForm .el-form-item:nth-child(2) {
  margin-left: 30px;
}
</style>


